<div class="journal-history-header">
  <div>
    <h2 mat-dialog-title class="journal-history-title">Journal History</h2>
    <p class="journal-history-subtitle">{{ containerLabel }}</p>
  </div>
  <button type="button" class="journal-history-close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<mat-dialog-content class="mat-typography">
  <div class="journal-history-table-container">
    <table mat-table [dataSource]="dataSource" class="journal-history-table">
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef>Date</th>
        <td mat-cell *matCellDef="let journal">{{ journal.date | date: 'medium' }}</td>
      </ng-container>

      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>Type</th>
        <td mat-cell *matCellDef="let journal">{{ journal.type }}</td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>Action</th>
        <td mat-cell *matCellDef="let journal">{{ journal.action }}</td>
      </ng-container>

      <ng-container matColumnDef="change">
        <th mat-header-cell *matHeaderCellDef>Change</th>
        <td mat-cell *matCellDef="let journal">{{ journal.change }}</td>
      </ng-container>

      <ng-container matColumnDef="productSku">
        <th mat-header-cell *matHeaderCellDef>Product SKU</th>
        <td mat-cell *matCellDef="let journal">{{ journal.productSku?.sku ?? journal.productSku?.name ?? '' }}</td>
      </ng-container>

      <ng-container matColumnDef="fromLocation">
        <th mat-header-cell *matHeaderCellDef>From</th>
        <td mat-cell *matCellDef="let journal">{{ journal.fromLocation?.name ?? journal.fromHeldByUser?.username ?? '' }}</td>
      </ng-container>

      <ng-container matColumnDef="toLocation">
        <th mat-header-cell *matHeaderCellDef>To</th>
        <td mat-cell *matCellDef="let journal">{{ journal.toLocation?.name ?? journal.toHeldByUser?.username ?? '' }}</td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>Description</th>
        <td mat-cell *matCellDef="let journal">{{ journal.description }}</td>
      </ng-container>

      <ng-container matColumnDef="responsibleUser">
        <th mat-header-cell *matHeaderCellDef>Responsible</th>
        <td mat-cell *matCellDef="let journal">{{ formatUser(journal) }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">No journal history found</td>
      </tr>
    </table>
  </div>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
</mat-dialog-content>

<mat-dialog-actions align="end" class="journal-history-actions">
  <mat-paginator
    [length]="totalCount"
    [pageIndex]="pageIndex"
    [pageSize]="pageSize"
    [pageSizeOptions]="[5, 10, 20]"
    showFirstLastButtons
    (page)="onPageChange($event)"
  >
  </mat-paginator>
</mat-dialog-actions>
